<template lang="pug">
div
    div.text-center.p-b-md
        img(v-bind:src="logo" width="100px")

    div.row
        div.col-sm-12.text-center
            small.block {{ order.outlet.details.company_name }}
            small.block {{ outlet.name }}
            small.block {{ order.outlet.address }}
            small.block {{ order.outlet.preference.phone }}
            small.block {{ receiptDateFormat(receipt.settled_date) }}
            small.block Invoice No.: {{ receiptNumberFormat(receipt) }}
            small.block(v-if="payment && payment.stan_no != null && enableUnleash") STAN No.: {{ payment.stan_no }}
            small.block(v-if="payment && payment.ref_number != null && enableUnleash") Ref No.: {{ payment.ref_number }}
            small.block(v-if="payment && payment.original_approval_code != null") Preauth Approval Code: {{ payment.original_approval_code }}
            small.block(v-if="payment && payment.approval_code != null") {{ payment.name == 'EDC' ? 'Final' : '' }} Approval Code: {{ payment.approval_code }}

        div.col-sm-12
            hr

        div.col-sm-12
            div.row(v-if="!hasOrderFuel && !retailMode")
                div.col-xs-5
                    small.pull-left Table
                    br
                    h5.pull-left {{ hasTable ? table.name : 'TAKEAWAY'  }}
                div.col-xs-3
                    small.pull-left Pax
                    br
                    h5.pull-left {{ hasTable ? orderTable.pax : 'N/A' }}
                div.col-xs-4(v-if="cashier")
                    small.pull-left Cashier
                    br
                    h5.pull-left {{ cashier.name }}

            div.row(v-if="!hasOrderFuel && retailMode")
                div.col-xs-4
                    small.pull-left POS
                    br
                    h5.pull-left {{ receipt.central.name }}

                div.col-xs-4(v-if="cashier")
                    small.pull-left Cashier
                    br
                    h5.pull-left {{ cashier.name }}

            // has fuel
            div(v-if="hasOrderFuel")

                // OPT
                div(v-if="orderFuel.terminal_type === 'OPT'")
                    div.row
                        div.col-xs-4.p-b-sm
                            small.block Pump
                            h5 {{ orderFuel.pump_id }}

                        div.col-xs-4.p-b-sm
                            small.block Fuel
                            h5.m-b-0 {{ orderFuel.fuel.name }}
                            small.block RM {{ orderFuel.price }} / L

                        div.col-xs-4.p-b-sm
                            small.block.text-capitalize {{ orderFuel.mode.toLowerCase() }}
                            h5.m-b-0 RM {{ orderFuel.limit }}
                            small.block {{ orderFuel.limit_volume }} L

                    div.row
                        div.col-xs-4.p-b-sm
                            small.block Final Amount
                            h5.m-b-0 RM {{ orderFuel.amount }}
                            small.block {{ orderFuel.volume }} L 

                        div.col-xs-4(v-if="orderFuel.refund != null")
                            small
                                .block(v-if="orderFuel.fcc_exception === 'DELIVERY_OVERRUN'") Overrun
                                .block(v-else-if="orderFuel.exception === 'OVERSHOOT'") Overshoot
                                .block(v-else-if="orderFuel.aborted_by") Abort Fuel
                                .block(v-else) Refund
                            h5.m-b-0 RM {{ Math.abs(orderFuel.refund.total_amount).toFixed(2) }}
                            small.block {{ receiptDateFormat(orderFuel.refund.refunded_at) }}c

                div(v-else)
                    div(v-if="order.central && cashier && orderFuel.subsidy != null")
                        div.row
                            div.col-xs-3.p-b-sm
                                small.block POS
                                h5 {{ order.central.name }}

                            div.col-xs-3.p-b-sm
                                small.block Cashier
                                h5 {{ cashier.name }}

                            div.col-xs-6.p-b-sm
                                small.block Pump
                                h5 {{ orderFuel.pump_id }}

                        div.row
                            div.col-xs-3.p-b-md
                                small.block Market Price
                                h5.m-b-0 {{ orderFuel.fuel.name }}
                                small.block RM {{ orderFuel.price }} / L

                            div.col-xs-3.p-b-md
                                small.block Subsidy Price
                                h5.m-b-0 {{ orderFuel.fuel.name }}
                                small.block RM {{ orderFuel.subsidy.price }} / L

                            div.col-xs-6.p-b-md
                                small.block Type
                                h5.m-b-0.text-capitalize {{ transactionType.toLowerCase() }}

                        div.row
                            div.col-xs-3.p-b-md
                                small.block.text-capitalize {{ orderFuel.mode.toLowerCase() }} Amount
                                h5.m-b-0 RM {{ orderFuel.limit }}
                                small.block {{ orderFuel.limit_volume }} L

                            div.col-xs-3.p-b-md
                                small.block Subsidy
                                h5.m-b-0 RM {{ orderFuel.subsidy.amount }}
                                small.block {{ orderFuel.subsidy.volume }} L

                            div.col-xs-6.p-b-md
                                small.block {{ orderFuel.subsidy.label == 'SKPS' ? 'MyKad Number' : 'Cash Card No' }}
                                h5.m-b-0 {{ orderFuel.subsidy.customer_id }}

                        div.row
                            div.col-xs-3
                                small.block Final Amount
                                h5.m-b-0 RM {{ orderFuel.amount }}
                                small.block {{ orderFuel.volume }} L

                            div.col-xs-6(v-if="orderFuel.refund != null")
                                small
                                    .block(v-if="orderFuel.fcc_exception === 'DELIVERY_OVERRUN'") Overrun
                                    .block(v-else-if="orderFuel.exception === 'OVERSHOOT' || orderFuel.fcc_exception === 'OVERSHOOT'") Overshoot
                                    .block(v-else-if="orderFuel.aborted_by") Abort Fuel
                                    .block(v-else) Refund
                                h5.m-b-0 RM {{ Math.abs(orderFuel.refund.total_amount).toFixed(2) }}
                                small.block {{ receiptDateFormat(orderFuel.refund.refunded_at) }}

                    div(v-else-if="order.central && cashier")
                        div.row
                            div.col-xs-4.p-b-sm
                                small.block POS
                                h5 {{ order.central.name }}

                            div.col-xs-4.p-b-sm
                                small.block Cashier
                                h5 {{ cashier.name }}

                            div.col-xs-4.p-b-sm
                                small.block Pump
                                h5 {{ orderFuel.pump_id }}

                        div.row
                            div.col-xs-4.p-b-sm
                                small.block Fuel
                                h5.m-b-0 {{ orderFuel.fuel.name }}
                                small.block RM {{ orderFuel.price }} / L

                            div.col-xs-4.p-b-sm
                                small.block.text-capitalize {{ orderFuel.mode.toLowerCase() }}
                                h5.m-b-0 RM {{ orderFuel.limit }}
                                small.block {{ orderFuel.limit_volume }} L

                            div.col-xs-4.p-b-sm
                                small.block Final Amount
                                h5.m-b-0 RM {{ orderFuel.amount }}
                                small.block {{ orderFuel.volume }} L

                        div.row
                            div.col-xs-4(v-if="orderFuel.refund != null")
                                small
                                .block(v-if="orderFuel.fcc_exception === 'DELIVERY_OVERRUN'") Overrun
                                .block(v-else-if="orderFuel.exception === 'OVERSHOOT' || orderFuel.fcc_exception === 'OVERSHOOT'") Overshoot
                                .block(v-else-if="orderFuel.aborted_by") Abort Fuel
                                .block(v-else) Refund 
                                h5.m-b-0 RM {{ Math.abs(orderFuel.refund.total_amount).toFixed(2) }}
                                small.block {{ receiptDateFormat(orderFuel.refund.refunded_at) }}

                    div(v-else)
                        div.row
                            div.col-xs-4.p-b-sm
                                small.block Pump
                                h5 {{ orderFuel.pump_id }}

                            div.col-xs-4.p-b-sm
                                small.block Fuel
                                h5.m-b-0 {{ orderFuel.fuel.name }}
                                small.block RM {{ orderFuel.price }} / L

                            div.col-xs-4.p-b-sm
                                small.block.text-capitalize {{ orderFuel.mode.toLowerCase() }}
                                h5.m-b-0 RM {{ orderFuel.limit }}
                                small.block {{ orderFuel.limit_volume }} L

                        div.row
                            div.col-xs-4.p-b-sm
                                small.block Final Amount
                                h5.m-b-0 RM {{ orderFuel.amount }}
                                small.block {{ orderFuel.volume }} L
        div.col-sm-12
            hr
</template>

<script>
import Feature from '@js/plugins/feature';
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Unleash from '@js/plugins/unleash';
import Auth from '@js/plugins/auth';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'outlet',
            'table',
            'orderFuel',
            'orderTable',
            'cashier',
            'hasTable',
            'grandTotal',
            'payments',
            'order',
            'transaction',
        ]),

        retailMode() {
            return Feature.hasFeature('retail');
        },

        hasOrderFuel() {
            return this.orderFuel != null;
        },

        payment() {
            let payment = this.payments.find(
                p => p.name === 'EDC' || 'IPT' || 'OPT',
            );

            if (!_.isEmpty(payment)) {
                return payment;
            }

            return null;
        },

        enableUnleash() {
            return Unleash.hasFeature('eps_report');
        },

        logo() {
            return Auth.franchise().logo;
        },

        transactionType() {
            return this.transaction.transaction_type
                ? this.transaction.transaction_type
                : this.transaction.data.transaction_type;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/details.vue